<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" v-html="trans[locale].academic_year"></label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_year"
                             :options="selector_year_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="false"
                             :close-on-select="true"
                             :hide-selected="false"
                             :internal-search="true"
                             :searchable="false"
                             :allow-empty="false"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" v-html="trans[locale].school_group_category"></label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_school_group_category"
                             :options="selector_school_category_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="true"
                             :hide-selected="false"
                             :internal-search="true"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" v-html="trans[locale].school_group"></label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_school_group"
                             :options="selector_school_group_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="true"
                             :hide-selected="false"
                             :internal-search="true"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" v-html="trans[locale].school_group_role"></label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_school_group_role"
                             :options="selector_school_group_role_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="true"
                             :hide-selected="false"
                             :internal-search="true"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].account_status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="active"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_active }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="disable"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_disable }}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group row" v-if="show_user_type && limit_user_type.length > 0">
            <label class="col-sm-3 col-form-label">{{ trans[locale].user_type }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_user_type"
                             :options="selector_user_type_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="false"
                             :clear-on-select="false"
                             :hide-selected="true"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].group_member }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_users"
                             :options="selector_user_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="is_multiple"
                             :close-on-select="false"
                             :hide-selected="true"
                             :searchable="true"
                             :internal-search="true"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :loading="loading"
                             :disabled="loading"
                             :show-labels="false"
                             :show-no-results="false"
                             :limit="limit" :limitText="limitText"
                             group-values="libs"
                             group-label="language"
                             :group-select="true"
                >
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../store/store';
    import UserSelector from './UserSelector';
    export default {
        mixins: [UserSelector],
        name: 'SelectorGroupUser',
        props: {
            show_user_type: {
                type: Boolean,
                required: false,
                default: () => {
                    return false;
                }
            },
            limit_years : {
                type: Array,
                required: false
            },
            limit_user_type: {
                type: Array,
                required: false,
                default: () => {
                    return [
                        'teacher',
                        'parent',
                        'student',
                    ];
                }
            },
            select_parent_by_student : {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        store,
        data() {
            return Object.assign(
                {
                    selector_selected_year: null,
                    selector_year_options: [],
                    selector_selected_school_group_category: null,
                    selector_school_category_options: [],
                    selector_selected_school_group: null,
                    selector_school_group_options: [],
                    selector_selected_school_group_role: null,
                    selector_school_group_role_options: [],
                    selector_selected_status: [ 'active' ],
                    selector_selected_user_type: null,
                    selector_user_type_options: [],
                }
            )
        },
        watch: {
            selector_selected_year: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_year]', 'gray');
                if (this.filter_state !== 'init') this.getGroupsOptions();
            }, store.getters.debounceMS),
            selector_school_category_options: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_school_category_options]', 'gray');
                this.getGroupRolesOptions();
            }, store.getters.debounceMS),
            selector_selected_school_group_category: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_school_group_category]', 'gray');
                this.getGroupsOptions();
            }, store.getters.debounceMS),
            selector_selected_school_group: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_school_group]', 'gray');
                this.getGroupRolesOptions();
            }, store.getters.debounceMS),
            selector_school_group_role_options: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_school_group_role_options]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
            selector_selected_school_group_role: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_school_group_role]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
            selector_selected_user_type: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_user_type]', 'gray');
                if (this.filter_state !== 'init') this.getGroupsOptions();
            }, store.getters.debounceMS),
            selector_selected_status: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_status]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
        },
        methods: {
            initialSelector() {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [initialSelector]', 'gray');
                this.getUserTypeOptions();
                this.getYearOptions();
                this.getGroupCategoriesOptions();
            },
            getUserTypeOptions() {
                let self = this;
                let url = '/api/options/school-group/user-type';
                let req_param = {
                    locale: self.locale,
                    limit_user_type: self.limit_user_type,
                };
                url = url + '?' + $.param(req_param);

                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getUserTypeOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getUserTypeOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    self.selector_user_type_options = response.data;
                    if (_.size(self.selector_user_type_options) == 1) {
                        self.selector_selected_user_type = self.selector_user_type_options;
                    }
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getUserTypeOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getYearOptions() {
                let self = this;
                let url = '/api/options/get-year?without_future=y';
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getYearOptions] => ' + url, 'gray');
                let method = 'get';
                self.selector_selected_year = null;
                let successCallBack = (response) => {
                    if (!_.isUndefined(self.limit_years))
                    {
                        let limited_year_options = [];
                        _.forEach(response.data, (year_item) => {
                            if (self.limit_years.indexOf(year_item.key) != -1) {
                                limited_year_options.push(year_item);
                            }
                        });
                        self.selector_year_options = limited_year_options;
                    } else {
                        self.selector_year_options = response.data;
                    }
                    self.selector_selected_year = _.first(self.selector_year_options);
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getYearOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(self.selector_year_options), 'success');
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getYearOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getGroupCategoriesOptions() {
                let self = this;
                let url = '/api/options/school-group/categories';

                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getGroupCategoriesOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getGroupCategoriesOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    self.selector_school_category_options = response.data;
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getGroupCategoriesOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getGroupsOptions() {
                let self = this;
                let url = '/api/options/school-group/groups';

                let categories = [];
                if (_.size(self.selector_school_category_options) > 0) {
                    if (_.isNull(self.selector_selected_school_group_category) || _.size(self.selector_selected_school_group_category) == 0) {
                        _.forEach(self.selector_school_category_options, (group_category) => {
                            if (!_.isUndefined(group_category.key)) {
                                categories.push(group_category.key);
                            }
                        });
                    } else {
                        _.forEach(self.selector_selected_school_group_category, (option) => {
                            if (!_.isUndefined(option.key)) {
                                categories.push(option.key);
                            }
                        });
                    }
                }
                let req_param = {
                    locale: self.locale,
                    year: _.isNull(self.selector_selected_year) ? null : self.selector_selected_year.key,
                    categories: categories
                };
                url = url + '?' + $.param(req_param);

                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getGroupsOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getGroupsOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    self.selector_school_group_options = response.data;

                    if(!_.isNull(self.selector_selected_school_group)
                        && !_.isUndefined(self.selector_selected_school_group)
                        && _.size(self.selector_selected_school_group) > 0) {
                        self.selector_selected_school_group = null;
                    }
                    else if(this.filter_state !== 'init') {
                        self.getGroupRolesOptions();
                    }
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getGroupsOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getGroupRolesOptions() {
                let self = this;
                let url = '/api/options/school-group/roles';

                let categories = [];
                if (_.size(self.selector_school_category_options) > 0) {
                    if (_.isNull(self.selector_selected_school_group_category) || _.size(self.selector_selected_school_group_category) == 0) {
                        _.forEach(self.selector_school_category_options, (group_category) => {
                            if (!_.isUndefined(group_category.key)) {
                                categories.push(group_category.key);
                            }
                        });
                    } else {
                        _.forEach(self.selector_selected_school_group_category, (option) => {
                            if (!_.isUndefined(option.key)) {
                                categories.push(option.key);
                            }
                        });
                    }
                }
                let groups = [];
                if (_.size(self.selector_school_group_options) > 0) {
                    if (_.isNull(self.selector_selected_school_group) || _.size(self.selector_selected_school_group) == 0) {
                        _.forEach(self.selector_school_group_options, (group) => {
                            if (!_.isUndefined(group.key)) {
                                groups.push(group.key);
                            }
                        });
                    } else {
                        _.forEach(self.selector_selected_school_group, (option) => {
                            if (!_.isUndefined(option.key)) {
                                groups.push(option.key);
                            }
                        });
                    }
                }

                let req_param = {
                    locale: self.locale,
                    year: _.isNull(self.selector_selected_year) ? null : self.selector_selected_year.key,
                    categories: categories,
                    groups: groups,
                };
                url = url + '?' + $.param(req_param);

                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getGroupsOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getGroupsOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    self.selector_school_group_role_options = response.data;
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getGroupsOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getUserOptions: _.debounce(function(){
                let self = this;
                let ignored_users = [];
                let url = '/api/options/school-group/members';

                let selected_users_ids = [];
                _.forEach(self.selector_selected_users, (item) => {
                    selected_users_ids.push(item.key);
                });

                let ignored_users_ids = [];
                _.forEach(self.selector_ignored_users, (item) => {
                    ignored_users_ids.push(item.key);
                });

                let user_types = [];
                if (_.size(self.selector_selected_user_type) > 0) {
                    _.forEach(self.selector_selected_user_type, (item) => {
                        user_types.push(item.key);
                    });
                } else {
                    _.forEach(self.selector_user_type_options, (item) => {
                        user_types.push(item.key);
                    });
                }

                let user_status = [];
                if (_.size(self.selector_selected_status) > 0) {
                    _.forEach(self.selector_selected_status, (item) => {
                        user_status.push(item);
                    });
                }

                let categories = [];
                if (_.size(self.selector_school_category_options) > 0) {
                    if (!_.isNull(self.selector_selected_school_group_category) && _.size(self.selector_selected_school_group_category) > 0) {
                        _.forEach(self.selector_selected_school_group_category, (option) => {
                            if (!_.isUndefined(option.key)) {
                                categories.push(option.key);
                            }
                        });
                    }
                }
                let groups = [];
                if (_.size(self.selector_school_group_options) > 0) {
                    if (!_.isNull(self.selector_selected_school_group) && _.size(self.selector_selected_school_group) > 0) {
                        _.forEach(self.selector_selected_school_group, (option) => {
                            if (!_.isUndefined(option.key)) {
                                groups.push(option.key);
                            }
                        });
                    }
                }

                let roles = [];
                if (_.size(self.selector_school_group_role_options) > 0) {
                    if (!_.isNull(self.selector_selected_school_group_role) && _.size(self.selector_selected_school_group_role) > 0) {
                        _.forEach(self.selector_selected_school_group_role, (option) => {
                            if (!_.isUndefined(option.key)) {
                                roles.push(option.key);
                            }
                        });
                    }
                }

                let req_param = {
                    extra: 'with_group',
                    locale: self.locale,
                    req_key: this.request_type,
                    select_parent_by_student: this.select_parent_by_student,
                    year: _.isNull(self.selector_selected_year) ? null : self.selector_selected_year.key,
                    categories: _.size(categories) ? categories : null,
                    groups: _.size(groups) > 0 ? groups : null,
                    roles: _.size(roles) > 0 ? roles : null,
                    ignored_users: _.size(ignored_users_ids) > 0 ? ignored_users_ids : null,
                    selected_users: _.size(selected_users_ids) > 0 ? selected_users_ids : null,
                    user_types: _.size(user_types) > 0 ? user_types : null,
                    user_status: _.size(user_status) > 0 ? user_status : null,
                    filter_state: 'standby',
                };

                // url = url + '?' + $.param(req_param);

                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getUserOptions] => ' + url, 'gray');
                let method = 'post';

                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getUserOptions]', 'success');
                    if (_.isUndefined(response.data[0].libs)) {
                        if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    } else {
                        if (this.is_debug) this.debugMessage(' Total Options: ' + _.size(response.data[0].libs), 'success');
                    }
                    self.selector_user_options = response.data;
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getUserOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.postOptions(url, method, req_param, successCallBack, failedCallBack);
            }, store.getters.debounceMS),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/SelectorGroupUser.vue